import { render } from "./DataFilter.vue?vue&type=template&id=e875fb9e&scoped=true"
import script from "./DataFilter.vue?vue&type=script&lang=js"
export * from "./DataFilter.vue?vue&type=script&lang=js"

import "./DataFilter.vue?vue&type=style&index=0&id=e875fb9e&scoped=true&lang=css"

import exportComponent from "C:\\projetos\\andamento-da-obra\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e875fb9e"]])

export default __exports__